import { PitchLocationChartConfigDto, PitcherSingleSessionReportChartConfigDto, PitchLocationGrouping } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

const PitcherSingleSessionPitchLocationChartSidebar = ({
  chartConfig,
  setTempLayout,
  tempLayout,
}: ChartConfigProps<PitchLocationChartConfigDto, PitcherSingleSessionReportChartConfigDto>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle('PitcherSingleSessionPitchLocationChart', chartConfig)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={['GroupOrType', 'PitchCall'] satisfies PitchLocationGrouping[]}
        selected={chartConfig.pitchLocationGrouping}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            pitcherSingleSessionPitchLocationChartConfig: {
              ...tempLayout.pitcherSingleSessionPitchLocationChartConfig,
              pitchLocationGrouping: selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

export default PitcherSingleSessionPitchLocationChartSidebar;
